import { dateFormater } from "../helpers";

const getTomorrowDate = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return dateFormater(tomorrow);
}

export default getTomorrowDate;